module.exports = __webpack_public_path__ + "static/media/about-autzu.8b47a02e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-autzu.svg
// module id = 1947
// module chunks = 0